import axios from 'axios';
import {auth} from '@src/db';
import {appConfig} from '@src/config';
import {typesAxReg} from '@common/status';

export class AxRegIntegrationClass {
  auxThis = null;
  idToken = '';
  currentCompanyId = '';
  currentUserId = '';

  // constructor(){
  //
  //   return this;
  // }

  setAuxThis(auxThis) {
    this.auxThis = auxThis;
    this.setCurrentCompanyId(this.auxThis.currentCompanyId);
    this.setCurrentUserId(this.auxThis.currentUser?.id);
  }

  setCurrentCompanyId(currentCompanyId) {
    this.currentCompanyId = currentCompanyId;
  }
  setCurrentUserId(currentUserId) {
    this.currentUserId = currentUserId;
  }

  /**
   * Função para pegar/atualizar o token de usuário do Firebase
   * @param  {boolean} forceRefresh
   * @returns {Promise<void>}
   */
  async updateTokenIdFirebase(forceRefresh=false) {
    await auth.currentUser.getIdToken(forceRefresh).then((idToken) => {
      this.idToken = idToken || '';
    }).catch(function(error) {
      this.auxThis && this.auxThis.$showError({title: 'Erro ao atualizar token do firebase'});
      console.error('error on get token', error);
    });
  }

  /**
   *
   * @param { 'getItemsToFrom' | 'setNewToFrom' | 'removeToFrom' | 'changeVisibilityToFrom' | 'createNewIntegration' | 'getIntegrations' | 'getIntegrationByCompanyId' | 'getIntegrationById' | 'setInstitution' | 'syncActivation' | 'consumeSingle' } type
   * @param {'get' | 'post' | 'delete'} method
   * @param {any} data
   * @param {boolean} showSuccess
   * @returns {Promise<any>}
   */
  async callAxiosIntegration(type,
    method, data = {}, showSuccess = false) {
    await this.updateTokenIdFirebase();
    const dataToCall = {
      method: method,
      url: `${appConfig.integrationsUrl}/axreg/`,
      headers: { 'Authorization': this.idToken },
      data: data || {},
    };
    const msgError = '';
    switch (type) {
      case 'getItemsToFrom':
        dataToCall.url += `tofrom/${this.currentCompanyId}`;
        break;
      case 'setNewToFrom':
      case 'removeToFrom':
        dataToCall.url += 'tofrom';
        break;
      case 'changeVisibilityToFrom':
        dataToCall.url += 'update_tofrom_visibility';
        break;
      case 'createNewIntegration':
        dataToCall.url += 'integration';
        break;
      case 'getIntegrationByCompanyId':
        dataToCall.url += `integration/${this.currentCompanyId}`;
        break;
      case 'getIntegrationById':
        dataToCall.url += `integration/${data.id}`;
        break;
      case 'getIntegrations':
        dataToCall.url += 'integration';
        break;
      case 'setInstitution':
        dataToCall.url += 'institution';
        break;
      case 'syncActivation':
        dataToCall.url += 'sync_activation';
        break;
      case 'consumeSingle':
        dataToCall.url += `consume_single/${this.currentCompanyId}/${data.axregId}`;
        break;
    }
    let result = {};
    try {
      // console.log('dataToCall', dataToCall)
      result = await axios(dataToCall);
      showSuccess && this.auxThis.$showSuccess();
    } catch (error) {
      if (error.response?.data?.error?.code === 'auth/id-token-expired') {
        console.warn('Get new token and try again');
        await this.updateTokenIdFirebase(true);
        result = await axios(dataToCall).catch(error => {
          console.error('Error on call axios integration', error);
          this.auxThis.$showError({title: msgError || ''});
        });
      } else {
        console.error('Error on call axios integration', error);
        this.auxThis.$showError({title: msgError || ''});
      }
    }
    return result;
  }

  /**
   *
   * @param {string} companyId
   * @returns {Promise<*|*[]>}
   */
  async getIntegrations(companyId= '') {
    let result = null;
    if (companyId) {
      result = await this.callAxiosIntegration('getIntegrationByCompanyId', 'get', {}, false);
    } else {
      result = await this.callAxiosIntegration('getIntegrations', 'get', {}, false);
    }

    return result?.data?.data || [];
  }

  /**
   *
   * @param {string} id
   * @returns {Promise<{}|*>}
   */
  async getIntegrationById(id) {
    const result = await this.callAxiosIntegration('getIntegrationById', 'get', {id: id}, false);
    if (result.status !== 200) { return {}; }
    return result.data.data[0];
  }

  /**
   *
   * @param {any} data
   * @returns {Promise<*>}
   */
  async setInstitution(data) {
    console.log('data', data);
    const result = await this.callAxiosIntegration('setInstitution', 'post', data, false);
    console.log('result: ', result);
    return result;
  }


  /**
   *
   * @param {'anesthetists' | 'surgeons' | 'healthInsurances' | 'hospitals'} type
   * @returns {string}
   */
  getTypeToSet(type) {
    return typesAxReg[type];
  }

  /**
   *
   * @param {any} data
   * @returns {Promise<void>}
   */
  async createNewIntegration(data) {
    await this.callAxiosIntegration('createNewIntegration', 'post', data, true);
  }

  async syncActivation(data) {
    await this.callAxiosIntegration('syncActivation', 'post', data, false);
  }

  /**
   *
   * @param {'anesthetists' | 'surgeons' | 'healthInsurances' | 'hospitals'} type
   * @param {any} item
   * @param {string} volanId
   * @returns {Promise<any>}
   */
  async setNewToFrom(type, item, volanId) {
    const save = {
      type : this.getTypeToSet(type),
      volanId : volanId,
      axregId : Number(item.axregId),
      companyId : this.currentCompanyId,
      userId: this.currentUserId,
    };
    // console.log('save setNewToFrom: ', save);
    return await this.callAxiosIntegration('setNewToFrom', 'post', save);
  }

  /**
   *
   * @param {'anesthetists' | 'surgeons' | 'healthInsurances' | 'hospitals'} type
   * @param {any} data
   * @returns {Promise<void>}
   */
  async removeToFrom(type, data) {
    if(!(await this.auxThis.$showConfirm({title: 'Tem certeza que deseja remover o de/para de: '+ data.volan?.name+' --> '+ data.name+' ?'}))) {
      return;
    }
    const save = {
      type : this.getTypeToSet(type),
      axregId : Number(data.axregId),
      companyId : this.currentCompanyId,
    };
    await this.callAxiosIntegration('removeToFrom', 'delete', save, true);
  }

  /**
   *
   * @param {'anesthetists' | 'surgeons' | 'healthInsurances' | 'hospitals'} type
   * @param {any} item
   * @param {boolean} visible
   * @param {boolean} showSuccess
   * @returns {Promise<any>}
   */
  async setVisibilityToFrom(type, item, visible, showSuccess=false) {
    const save = {
      type : this.getTypeToSet(type),
      axregId : Number(item.axregId),
      companyId : this.currentCompanyId,
      userId: this.currentUserId,
      visible: !!visible,
    };
    // console.log('save setVisibilityToFrom: ', save);
    return await this.callAxiosIntegration('changeVisibilityToFrom', 'post', save, showSuccess);
  }

  async consumeSingle(axregId) {
    if (!axregId) {
      this.auxThis.$showError({title: 'axregId não informado'});
      return;
    }
    const data = {
      axregId: axregId,
    };
    return await this.callAxiosIntegration('consumeSingle', 'get', data);
  }
}


// Mock new integration
// {
//   id : string,
//   companyId : string,
//   name : string,
//   groupId: number,
//   integratorKey : string,
//   institutionKey : string,
//   type : string? (default = 'AXREG'),
//   active : boolean? (default = true),
//   lastDateSync : {
//     eventLastDate : string? (default = "2023-01-01T00:00:00"),
//     insurancesLastDate : string? (default = ""),
//     patientLastDate : string? (default = ""),
//     surgeonLastDate : string? (default = ""),
//     anesthetistLastDate : string? (default = ""),
//     proceduresLastDate : string? (default = ""),
//     proceduresTableLastDate : string? (default = "")
//   },
//   institutions: [
//     {
//       axregId: number,
//       active: boolean? (default = true),
//       name: string,
//       cnpj: string? (default = null)
//       type: AXRegInstitutionType? (default = null)
//       volanHospitalId: string? (default = null)
//       integratorKey: string? (default = null),
//       institutionKey : string? (default = null)
//     }
//   ] (default = [])
// }

// export enum AXRegInstitutionType {
//   HOSPITAL = 'HOSPITAL',
//   DOCTORS_OFFICE = 'DOCTORS_OFFICE',
//   CLINIC = 'CLINIC'
// }


















